var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "eu-flex eu-column eu-row_md" }, [
    _c("div", { staticClass: "eu-flex-item eu-basis_4_md" }, [
      _c("div", { staticClass: "emd-form-group" }, [
        _c("label", { staticClass: "emd-label", attrs: { for: "zipcode" } }, [
          _vm._v(_vm._s(_vm.$t("zipcode"))),
        ]),
        _c("p", { staticClass: "emd-text" }, [
          _vm._v(_vm._s(_vm.address.zip_code)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "eu-flex-divider" }),
    _c("div", { staticClass: "eu-flex-item eu-basis_12" }, [
      _c("div", { staticClass: "emd-form-group" }, [
        _c("label", { staticClass: "emd-label", attrs: { for: "street" } }, [
          _vm._v(_vm._s(_vm.$t("street"))),
        ]),
        _c("p", { staticClass: "emd-text" }, [
          _vm._v(_vm._s(_vm.address.street + ", " + _vm.address.number)),
        ]),
        _c("p", { staticClass: "emd-text" }, [
          _vm._v(_vm._s(_vm.address.complement)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "eu-flex-item eu-basis_2_md" }, [
      _c("div", { staticClass: "emd-form-group" }, [
        _c(
          "label",
          { staticClass: "emd-label", attrs: { for: "neighborhood" } },
          [_vm._v(_vm._s(_vm.$t("neighborhood")))]
        ),
        _c("p", { staticClass: "emd-text" }, [
          _vm._v(_vm._s(_vm.address.neighborhood)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "eu-flex-item eu-basis_4_md" }, [
      _c("div", { staticClass: "emd-form-group" }, [
        _c("label", { staticClass: "emd-label", attrs: { for: "city" } }, [
          _vm._v(_vm._s(_vm.$t("city"))),
        ]),
        _c("p", { staticClass: "emd-text" }, [
          _vm._v(
            _vm._s(
              _vm.address.city +
                ", " +
                _vm.address.state +
                " - " +
                _vm.address.country
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }